
import styled from "styled-components"
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from "react-redux";
import { updateTotalHighwayPrice } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const InputNumberExtraPrices = ({ name, labelText, inputWidth, ek=""}) => {

    const dispatch = useDispatch()

    const {
        totalHighwayPrice
    } = useSelector(state => state.nakliyeHesaplama)

    const handleChange = (e) => {
        dispatch(updateTotalHighwayPrice(parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0))
    }

  return (
    <Container value={totalHighwayPrice} radius={"5px"} inputWidth={inputWidth}>
        <NumericFormat type="text" id={"text"} thousandSeparator={'.'} decimalSeparator={','} suffix={totalHighwayPrice ? ek : ""}  onChange={handleChange} value={totalHighwayPrice || ""} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default InputNumberExtraPrices